import React from 'react';

const PaymentIcon = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7135 0.714619H0V10.9998H13.7135V0.714619ZM12.6586 9.97125H1.05489V1.74313H12.6586V9.97125Z"
        fill="white"
      />
      <path
        d="M14.934 3.38117V12.2428H2.66797V13.2854H16.0006V3.38117H14.934Z"
        fill="white"
      />
      <path
        d="M6.85633 8.40436C8.11658 8.40436 9.14192 7.26361 9.14192 5.86144C9.14192 4.45928 8.11658 3.31853 6.85633 3.31853C5.59609 3.31853 4.57074 4.45925 4.57074 5.86144C4.57074 7.26364 5.59609 8.40436 6.85633 8.40436ZM6.85633 4.35743C7.55649 4.35743 8.1261 5.03214 8.1261 5.86144C8.1261 6.69075 7.55649 7.36545 6.85633 7.36545C6.15618 7.36545 5.58656 6.69075 5.58656 5.86144C5.58656 5.03214 6.15618 4.35743 6.85633 4.35743ZM2.28516 3.00011H3.30097V8.71408H2.28516V3.00011ZM10.4117 3.00011H11.4275V8.71408H10.4117V3.00011Z"
        fill="white"
      />
    </svg>
  );
};

const CalendarIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="#C7C9C7" />
      <path
        d="M16 18C15.7167 18 15.479 17.904 15.287 17.712C15.095 17.52 14.9993 17.2827 15 17C15 16.7167 15.096 16.479 15.288 16.287C15.48 16.095 15.7173 15.9993 16 16C16.2833 16 16.521 16.096 16.713 16.288C16.905 16.48 17.0007 16.7173 17 17C17 17.2833 16.904 17.521 16.712 17.713C16.52 17.905 16.2827 18.0007 16 18ZM12 18C11.7167 18 11.479 17.904 11.287 17.712C11.095 17.52 10.9993 17.2827 11 17C11 16.7167 11.096 16.479 11.288 16.287C11.48 16.095 11.7173 15.9993 12 16C12.2833 16 12.521 16.096 12.713 16.288C12.905 16.48 13.0007 16.7173 13 17C13 17.2833 12.904 17.521 12.712 17.713C12.52 17.905 12.2827 18.0007 12 18ZM20 18C19.7167 18 19.479 17.904 19.287 17.712C19.095 17.52 18.9993 17.2827 19 17C19 16.7167 19.096 16.479 19.288 16.287C19.48 16.095 19.7173 15.9993 20 16C20.2833 16 20.521 16.096 20.713 16.288C20.905 16.48 21.0007 16.7173 21 17C21 17.2833 20.904 17.521 20.712 17.713C20.52 17.905 20.2827 18.0007 20 18ZM16 22C15.7167 22 15.479 21.904 15.287 21.712C15.095 21.52 14.9993 21.2827 15 21C15 20.7167 15.096 20.479 15.288 20.287C15.48 20.095 15.7173 19.9993 16 20C16.2833 20 16.521 20.096 16.713 20.288C16.905 20.48 17.0007 20.7173 17 21C17 21.2833 16.904 21.521 16.712 21.713C16.52 21.905 16.2827 22.0007 16 22ZM12 22C11.7167 22 11.479 21.904 11.287 21.712C11.095 21.52 10.9993 21.2827 11 21C11 20.7167 11.096 20.479 11.288 20.287C11.48 20.095 11.7173 19.9993 12 20C12.2833 20 12.521 20.096 12.713 20.288C12.905 20.48 13.0007 20.7173 13 21C13 21.2833 12.904 21.521 12.712 21.713C12.52 21.905 12.2827 22.0007 12 22ZM20 22C19.7167 22 19.479 21.904 19.287 21.712C19.095 21.52 18.9993 21.2827 19 21C19 20.7167 19.096 20.479 19.288 20.287C19.48 20.095 19.7173 19.9993 20 20C20.2833 20 20.521 20.096 20.713 20.288C20.905 20.48 21.0007 20.7173 21 21C21 21.2833 20.904 21.521 20.712 21.713C20.52 21.905 20.2827 22.0007 20 22ZM9 26C8.45 26 7.979 25.804 7.587 25.412C7.195 25.02 6.99934 24.5493 7 24V10C7 9.45 7.196 8.979 7.588 8.587C7.98 8.195 8.45067 7.99933 9 8H10V6H12V8H20V6H22V8H23C23.55 8 24.021 8.196 24.413 8.588C24.805 8.98 25.0007 9.45067 25 10V24C25 24.55 24.804 25.021 24.412 25.413C24.02 25.805 23.5493 26.0007 23 26H9ZM9 24H23V14H9V24Z"
        fill="white"
      />
    </svg>
  );
};

const DeliveryTypeIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="8" fill="#C7C9C7" />
      <path
        d="M24 17C24.6 17 25.1 17.2 25.5 17.6C25.8 18 26 18.5 26 19L18 22L11 20V11H12.9L20.2 13.7C20.7 13.9 21 14.3 21 14.8C21 15.1 20.9 15.4 20.7 15.6C20.5 15.8 20.1 16 19.8 16H17L15.2 15.3L14.9 16.2L17 17H24ZM5 11H9V22H5V11Z"
        fill="white"
      />
    </svg>
  );
};

const InvoiceReceiptIcon = () => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.07143 6.4H7.92857M4.07143 8.8H7.92857M4.07143 4H7.92857M1.5 1.6C1.5 1.44087 1.56773 1.28826 1.68829 1.17574C1.80885 1.06321 1.97236 1 2.14286 1H9.85714C10.0276 1 10.1912 1.06321 10.3117 1.17574C10.4323 1.28826 10.5 1.44087 10.5 1.6V13L8.25 11.5L6 13L3.75 11.5L1.5 13V1.6Z"
        stroke="black"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { PaymentIcon, CalendarIcon, DeliveryTypeIcon, InvoiceReceiptIcon };
